const anatomicalModelFeaturesConstants = {
  Isocenter: 'Isocenter',
  CINE: 'CINE',
  MOLLI: 'MOLLI',
  Perfusion: 'Perfusion',
  Motion: 'Motion',
  tissueMagneticProperties: 'Tissue magnetic properties',
  coilTypes: 'Coil types',
  defaultCardiacPhase: 'Default cardiac phase',
  breathingMode: 'Breathing mode',
  physiologicalMotion: 'Physiological motion',
  t2_star: 'T2Star',
  fuzzyMode: 'Fuzzy mode',
  SWI: 'SWI',
  CS: 'CS',
  brainCondition: 'Brain Condition',
  heartCondition: 'Heart Condition',
};

export default anatomicalModelFeaturesConstants;
